/* eslint-disable max-len */
import {observable, action} from 'mobx';
import {langList, LANG_CODE} from '@constant/system';
import BaseStore from './baseStore';

export const CURRENT_LANG_KEY = 'currentLanguage';
class LanguageStore extends BaseStore {
  @observable supportLanguages = [];

  // * prev: default language is en-US, now: check user IP to set default language, handled in layout
  @observable currentLanguage = '';
  // @observable currentLanguage = LANG_CODE.EN_US;

  @action initLanguage(initStore) {
    const {supportLanguages, currentLanguage} = initStore;
    this.supportLanguages = supportLanguages;
    if (typeof window !== 'undefined') {
      const defaultUserLang = window.localStorage.getItem(CURRENT_LANG_KEY);
      if (defaultUserLang && langList.some(lang => lang.value === defaultUserLang)) {
        // * setting language after refresh page
        this.setLanguage(defaultUserLang);
      } else {
        this.setLanguage(currentLanguage);
      }
    }
    this.isReady = true;
  }

  @action setLanguage(languageId) {
    this.currentLanguage = languageId;
    window.localStorage.setItem(CURRENT_LANG_KEY, languageId);
  }

  getLanguage(languageId) {
    const languages = [...this.supportLanguages];
    for (let i = 0; i < languages.length; i += 1) {
      if (languages[i].id === languageId) {
        return languages[i];
      }
    }
    return null;
  }
}

export default LanguageStore;

export const languageStore = new LanguageStore();
